import type { ReactElement } from "react";

type EmptyStateProps = {
  title: ReactElement;
  message?: ReactElement;
  action?: ReactElement;
};

const EmptyStateContent: FC<EmptyStateProps> = ({ title, message, action }) => (
  <>
    <div className="max-w-sm text-center lg:ml-6 lg:text-left xl:max-w-4xl">
      {title && <p className="text-xl/8 font-medium leading-7">{title}</p>}
      {message && (
        <p className="mt-5 text-base text-muted-foreground lg:mt-1">
          {message}
        </p>
      )}
    </div>
    {action && <div className="mt-8 xl:mt-0 xl:ml-auto">{action}</div>}
  </>
);

export default EmptyStateContent;
